import { put, call } from 'redux-saga/effects';

import { getVLearnApp } from '@api/dashboard';
import { HTTP_FORBIDDEN } from '@constants/http-codes';
import { getVlearnAppSuccess, getVlearnAppFailure } from '@store/dashboard/dashboard.actions';
import { toastError } from '@store/notifications/notifications.action';

export const handleAppRequestSaga = function* ({ payload }) {
  try {
    const response = yield call(getVLearnApp);

    if (response.status === HTTP_FORBIDDEN) {
      yield call(payload.onFailure);
      return yield put(getVlearnAppFailure({ appName: payload.appName }));
    }

    if (response.data?.url) {
      yield put(getVlearnAppSuccess({ appName: payload.appName }));
      window.open(response.data.url);
    } else {
      throw new Error('URL missing');
    }
  } catch (e) {
    yield put([
      toastError({
        message: {
          id: 'global.notification.api-error-default',
          defaultMessage: 'An unexpected error occurred. Please try again.',
        },
      }),
      getVlearnAppFailure({ appName: payload.appName }),
    ]);
  }
};
